import React from 'react'
import { withRouter } from 'react-router-dom'
import congress3 from '../assets/img/congress3.jpg'
import ImageUploader from 'react-images-upload'
import ReactLoading from 'react-loading';


import izdavacka from '../assets/img/izdavacka.jpg'
import aktuelnosti from '../assets/img/aktuelnosti111.jpg'
import { userPath } from '../constants/user.constants'


class Registration extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            vocation: '',
            company: '',
            address: '',
            country: '',
            phone: '',
            email: '',
            addParticipansMsg: "",
            images: [],
            isLoading: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevProps) {
        if(nextProps.addParticipansMsg !== prevProps.addParticipansMsg) {
            if(localStorage.getItem('prijava')) {
                localStorage.removeItem('prijava')
                return {
                    addParticipansMsg: nextProps.addParticipansMsg,
                    isLoading: false
                }
            }
        }
        if(nextProps.addParticipansMsg === "Uspjesna prijava!"){
            if(prevProps.addParticipansMsg === "Uspjesna prijava!") {
                if(!localStorage.getItem("prijava")) {
                    return {
                        addParticipansMsg: '',
                        isLoading: false
                    }
                }
            }
        }
        return null
    }

    changeName = (input) => {   
        this.setState({
            name: input.target.value
        })
    }
    changeVocation = (input) => {   
        this.setState({
            vocation: input.target.value
        })
    }
    changeCompany = (input) => {   
        this.setState({
            company: input.target.value
        })
    }
    changeAddress = (input) => {   
        this.setState({
            address: input.target.value
        })
    }
    changeCountry = (input) => {   
        this.setState({
            country: input.target.value
        })
    }
    changePhone = (input) => {   
        this.setState({
            phone: input.target.value
        })
    }
    changeEmail = (input) => {   
        this.setState({
            email: input.target.value
        })
    }

    resetFields = () => {
        this.setState({
            name: "",
            vocation: "",
            company: "",
            address: "",
            country: "",
            phone: "",
            email: "",
            addParticipansMsg: "",
            images: [],
        })
    }

    submitForm = (e) => {
        e.preventDefault()
        this.setState({isLoading: true})
        let member = {
            name: this.state.name,
            vocation: this.state.vocation,
            company: this.state.company,
            address: this.state.address,
            country: this.state.country,
            phone: this.state.phone,
            email: this.state.email,
            paid: 0,
            images: this.state.images[0]
        }

        this.props.addParticipans(member)
        this.resetFields()
    }

    onDrop = (images) => {
        this.setState({
            // images: this.state.images.concat(images)
            images: images
        })
    }


    render() {
        return( 
            <>
                {this.state.addParticipansMsg === "Uspjesna prijava!" ? alert(this.state.addParticipansMsg): ""}

                {
                    this.state.isLoading
                    ?
                    <div style={{paddingLeft: '45%', paddingTop:'20px', paddingBottom:'20px'}}>
                        <ReactLoading type='spin' color='red'/>
                        <p style={{marginLeft:'-20px', paddingTop:'10px', paddingBottom:'10px'}}>Molimo sačekajte!</p>
                    </div>
                    :
                    <>
                    <div className="container">
                        <div className="row" style={{paddingLeft:'5px'}}>
                            <div className="row">
                                {/* <div className='col-xs-6 col-xs-offset-3'>
                                    <p>Agenda:</p>
                                    <img className="col-xs-12 col-md-12 img-responsive text-center showPages" src={congress2} alt="img1" onClick={this.showCongressPage} title="Kongres"/>
                                </div> */}

                                <div className="col-sm-12 col-md-4 col-md-offset-4">
                                        {/* className="col-sm-5" */}
                                        <form name="addForm" style={{padding: '10px'}} onSubmit={this.submitForm}>
                                        {/* <div className="col-md-6"> */}
                                            <h4 className="box-title" style={{textAlign:"center", paddingTop:'10px'}}>Registracija</h4>
                                            <div className="box-body">
                                                <div className="form-group">
                                                    <label>Ime i prezime*</label>
                                                    <input minLength={7} maxLength={35} type="text" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite ime i prezime"  value={this.state.name} onChange={this.changeName} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label>Zvanje (titula, specijalnost)*</label>
                                                    <input minLength={5} maxLength={35} type="text" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite zvanje"  value={this.state.vocation} onChange={this.changeVocation} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label>Ustanova u kojoj radite*</label>
                                                    <input minLength={5} maxLength={35} type="text" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite naziv ustanove"  value={this.state.company} onChange={this.changeCompany} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label>Adresa ustanove*</label>
                                                    <input minLength={5} maxLength={35} type="text" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite adresu ustanove"  value={this.state.address} onChange={this.changeAddress} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label>Država*</label>
                                                    <input minLength={5} maxLength={35} type="text" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite naziv države"  value={this.state.country} onChange={this.changeCountry} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label >Telefon*</label>
                                                    <input type="number" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite broj telefona"  value={this.state.phone} onChange={this.changePhone} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                                <div className="form-group">
                                                    <label >E-mail*</label>
                                                    <input minLength={7} maxLength={35} type="email" className="form-control" style={{borderRadius: '5px'}} placeholder="Unesite email" value={this.state.email} onChange={this.changeEmail} required />
                                                    <span style={{'color':'red'}}></span>
                                                </div>
                                            </div>
                                    
                                            <div className="form-group">
                                                <label>Rad</label>
                                                <ImageUploader
                                                    // withPreview={true}
                                                    withPreview={this.state.images?.length > 0 ? true: false}
                                                    // withIcon={true}
                                                    buttonText='Odaberite'
                                                    onChange={this.onDrop}
                                                    imgExtension={['.jpg', '.gif', '.png', '.pdf', 'docx']}
                                                    maxFileSize={5242880}
                                                    singleImage={true}
                                                    label='Odaberite file za upload'
                                                    value={this.state.images}
                                                />
                                            </div>
                                            <div className="box-footer" style={{textAlign:"center"}}>
                                                <button type="submit" className="btn btn-default" style={{borderRadius:'5px', marginBottom: '10px', border: "0", width:'100%'}}>Pošalji</button>
                                            </div>
                                    </form>


                                </div>

                            </div>

                        </div>
                    </div>




                    </>
                }







                {/* <PageHeader /> */}
                {/* <div className="contain-wrapp gray-container paddingbot-clear"> */}
                    {/* <div style={{marginBottom: "30px", marginTop: "-15px"}}> */}


                {/* </div> */}







            </>
        )
    }
}

export default withRouter(Registration)